import React from 'react';
import TagManager from 'react-gtm-module';
import $ from 'jquery';
import { countriesAPIs } from '../api';
import { amountRegex, contactRegex, emailRegex, isActiveRegex, mobileDeviceRegex, multipleWhiteSpace, numericValueRegex, specialCharacterRegexExceptSpace } from '../Regex';
import { isMobile } from 'react-device-detect';
import { S3_BUCKET } from '../constants';
import { GTM_EVENTS, PAGENAME_CONSTANTS } from '../constants';

export const getDateReadableFormat = (dateString) => {
    const options = { day: "2-digit", year: "numeric", month: "long" }
    return new Date(dateString).toLocaleDateString(undefined, options);
}

export const renderHTML = (rawHTML) => React.createElement(
    "div",
    {
        dangerouslySetInnerHTML:
            { __html: rawHTML }
    });

export const getFirstLetter = (name) => {
    let result = "";
    if (name.split(" ").length > 1) {
        // at least 2 strings
        result = name.substr(0, name.indexOf(" "));
    } else {
        result = name;
    }
    return result;
}

export const getCountryIcon = (iconName) => {
    try {
        return require('../assets/icons/flags/' + iconName + '.svg');
    }
    catch {
        return ""
    }
}

export const isValidAmount = (amount) => {
    if (amountRegex.test(amount))
        return true
    else return false
}

export const isValidEmail = (email) => {
    return emailRegex.test(email) ? true : false
}

export const isValidContact = (contact) => {
    if (contactRegex.test(contact))
        return true
    else return false
}

export const addTransactionFee = (amount, transactionFee) => {
    const transactionAmount = (transactionFee / 100) * amount;
    return (parseFloat(amount) + parseFloat(transactionAmount)).toFixed(2)
}

export const getGiftAidAmount = (donationAmount) => {
    return 0.25 * donationAmount
}

export const getCountryStates = async (countryId) => {
    try {
        const response = await countriesAPIs.getCountryStates(countryId);
        return response.data.data;
    }
    catch { return false }
}

export const isMobileDevice = () => {
    let check = false;
    (function (a) {
        if (mobileDeviceRegex[0].test(a) || mobileDeviceRegex[1].test(a.substr(0, 4)))
            check = true;
    })
        (navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const getIntegerValuesFromString = (string) => {
    return string.replace(/\D/g, '');
}

export const convertFirstLetterToUpperCase = (string) => {
    return string ? string.charAt(0).toUpperCase() + string.slice(1) : ''
}

export const displayError = (errorMessage) => {
    return errorMessage ? true : false
}

export const isActive = (string) => {
    return isActiveRegex.test(string)
}

export const containsSpecialCharacters = (string) => {
    return specialCharacterRegexExceptSpace.test(string)
}

export const containsNumericValue = (string) => {
    return numericValueRegex.test(string)
}

export const getPercentage = (value, totalValue) => {
    return (value / totalValue) * 100;
}

export const replaceMultipleWhiteSpaces = (string) => {
    return string.replace(multipleWhiteSpace, ' ');
}

export const trimSpacesAround = (string) => {
    let trimmedString = string;
    if (string.charAt(0) == ' ')
        trimmedString = trimmedString.substring(1);

    if (string.charAt(string.length - 1) == ' ')
        trimmedString = trimmedString.substring(0, trimmedString.length - 1)

    return trimmedString;

}

export const debounce = (func, timeLimit) => {
    let timer;
    return function (...args) {
        const context = this;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            func.apply(context, args);
        }, timeLimit);
    };
};

export const compiledName = (name) => {
    const removedWhiteSpaces = replaceMultipleWhiteSpaces(name);
    return trimSpacesAround(removedWhiteSpaces);
}

export const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);

    if (!element) {
        console.error(`No element found by the id "${elementId}", did you change or remove the id of any element?`);
        return
    }

    element.scrollIntoView({ behavior: "smooth", });
}

// The totalDonationAmount function adds the transaction fee of payment method to the
// donation amount iff the user wants to cover it, or else the transaction fee will not add
// to the donation amount
export const totalCheckoutDonation = (state) => {
    return state.coverTheTransactionFee ?
        addTransactionFee(state.donationAmount, state.transactionFeePercentage) :
        parseFloat(state.donationAmount).toFixed(2)
}

export const rollBackToDefaultCoverOnError = (event) => {
    event.target.onerror = null;
    event.target.src = S3_BUCKET + 'medium/fundraiser-pages/September2020/fc-128-1599224373.jpg'
}

export const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
}

export const getQueryParams = () => {
    const searchString = window.location.search.slice(1);
    if (searchString) {
        const queryParams = searchString.split("&");

        const queryParamsJson = {};

        for (const param of queryParams) {
            let values = param.split("=");

            queryParamsJson[values[0]] = values[1]
        }


        return queryParamsJson;
    }

}

export const getGTMEventFromName = (name) => {

    switch (name) {
        case PAGENAME_CONSTANTS.HOME:
            return GTM_EVENTS.HOME_VIEWED

        case PAGENAME_CONSTANTS.LOGIN:
            return GTM_EVENTS.LOGIN_VIEWED

        case PAGENAME_CONSTANTS.PROFILE:
            return GTM_EVENTS.PROFILE_PAGE

        case PAGENAME_CONSTANTS.DASHBOARD:
            return GTM_EVENTS.DASHBOARD

        case PAGENAME_CONSTANTS.PERSONAL_FUNDRAISERS:
            return GTM_EVENTS.PERSONAL_FUNDRAISERS

        case PAGENAME_CONSTANTS.TEAM_FUNDRAISERS:
            return GTM_EVENTS.TEAM_FUNDRAISERS

        case PAGENAME_CONSTANTS.DONATION_HISTORY:
            return GTM_EVENTS.DONATION_HISTORY

        case PAGENAME_CONSTANTS.SETTINGS:
            return GTM_EVENTS.SETTINGS

        case PAGENAME_CONSTANTS.FUNDRAISER:
            return GTM_EVENTS.FUNDRAISER

        default:
            return null
    }
}

export function currencyNeedsSpace(symbol) {
  if (!symbol || typeof symbol !== 'string') return false;

  // Trim and check if it's letters only
  const trimmed = symbol.trim();

  // Letters only → needs space
  if (/^[A-Za-z]+$/.test(trimmed)) return true;

  // Otherwise symbol → no space
  return false;
}

export function decodeJwt(token) {
    const parts = token.split('.');
    if (parts.length !== 3) throw new Error("Invalid JWT");

    const payload = parts[1]; // middle part
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
        atob(base64)
            .split('')
            .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
            .join('')
    );

    return JSON.parse(json);
}
